import { render, staticRenderFns } from "./WizardPriceBase.vue?vue&type=template&id=4efb0688&scoped=true"
import script from "./WizardPriceBase.vue?vue&type=script&lang=js"
export * from "./WizardPriceBase.vue?vue&type=script&lang=js"
import style0 from "./WizardPriceBase.vue?vue&type=style&index=0&id=4efb0688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb0688",
  null
  
)

export default component.exports